<template>
    <div
        id="shortlisting-panel-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <base-text type="h3" class="heading">{{ data.heading }}</base-text>
        <div class="shortlisting-panel-grid">
            <team-member
                v-for="(shortlister, index) in data.shortlisters"
                :key="index"
                :name="shortlister.name"
                :position="shortlister.position"
                :portfolio="shortlister.weblink || null"
                :photo="shortlister.photo"
            />
        </div>
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/shortlisting-panel.md';
    import TeamMember from '../components/TeamMember';

    export default {
        name: 'shortlisting-panel',

        mixins: [dataLoader(data)],

        components: {
            TeamMember,
        },
    };
</script>

<style lang="scss" scoped>
    #shortlisting-panel-page {
        margin: 150px 0;

        &.tablet,
        &.mobile {
            margin: 100px 0;
        }

        .heading {
            margin-bottom: $standard-space;
        }

        &.mobile {
            .heading {
                margin-bottom: $standard-space-mobile;
            }
        }

        .shortlisting-panel-grid {
            display: grid;
            grid-gap: 30px;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        }

        &.tablet,
        &.mobile {
            .shortlisting-panel-grid {
                grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            }
        }
    }
</style>
